import type { FxRateProvider } from "../interfaces";

/**
 * Manual FX rate provider — placeholder. Phase 6a accepts FX rates entered
 * directly in the form; this provider has no preset rates to look up. Phase
 * 11 adds TcmbMcpFxRateProvider, AiSuggestedFxRateProvider, etc., alongside.
 */
export class ManualFxRateProvider implements FxRateProvider {
  readonly id = "manual";
  // TODO(6a.6): replace with i18n key (e.g. t("fx.providers.manual"))
  readonly displayName = "Manuel";
  readonly isAvailable = true;

  async getRate(): Promise<number | null> {
    // Manual provider has no preset rates; UI accepts user input directly.
    return null;
  }
}
